module.exports = __webpack_public_path__ + "img/user.6d93a638.png";